import { render, staticRenderFns } from "./DeleteConfirmPopup.vue?vue&type=template&id=c51321ba&scoped=true&"
import script from "./DeleteConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeleteConfirmPopup.vue?vue&type=style&index=0&id=c51321ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51321ba",
  null
  
)

export default component.exports